import * as betgalaxy from './PaymentStateNotification.styles.betgalaxy';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
};
